// const apiHost = 'http://localhost:55136';
//const  apiHost='http://101.251.196.23:8087';
const apiHost = 'https://api.asstar.com';
export default {
    apiHost
}